import { useEffect, useRef, useState } from "react";
import SelectOneItem from "./SelectOneItem";

import * as c from "./SelectMoreItem.module.css";

type Option = {
  id: number;
  value: string;
  isRequired: boolean;
  groupId: number | null;
  groupName: string;
};

interface SelectMoreItemProps {
  groupName: string;
  groupOptions: Option[];
  selectedOption: string | null;
  onSelect: (value: string, id: number) => void;
  openDropdown: string | null;
  onDropdownToggle: (groupName: string) => void;
}

const BOTTOM_BUTTON_HEIGHT = 99;

function SelectMoreItem({
  groupName,
  groupOptions,
  selectedOption,
  onSelect,
  openDropdown,
  onDropdownToggle,
}: SelectMoreItemProps) {
  const [isSelected, setIsSelected] = useState(false);
  const [dropUp, setDropUp] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleOptionSelect = (value: string, id: number) => {
    onDropdownToggle(groupName);
    onSelect(value, id);
  };

  const handleDropdown = () => {
    if (containerRef.current && openDropdown !== groupName) {
      const triggerRect = containerRef.current.getBoundingClientRect();
      const availableBelow = window.innerHeight - triggerRect.bottom - BOTTOM_BUTTON_HEIGHT;
      const availableAbove = triggerRect.top;
      const dropdownMaxHeight = 172;

      setDropUp(availableBelow < dropdownMaxHeight + 16 && availableAbove > availableBelow);
    }
    onDropdownToggle(groupName);
  };

  useEffect(() => {
    setIsSelected(groupOptions.some((option) => option.value === selectedOption));
  }, [selectedOption]);

  return (
    <>
      <div
        ref={containerRef}
        className={`${c["select-one-container"]} ${isSelected ? c["selected"] : ""}`}
      >
        <input
          type="radio"
          id={`checkbox_for_${groupName}`}
          checked={isSelected}
          onClick={handleDropdown}
          readOnly
        />
        <label htmlFor={`checkbox_for_${groupName}`}>
          {groupOptions.some((option) => option.value === selectedOption)
            ? selectedOption
            : groupName}
        </label>

        {openDropdown === groupName && (
          <div
            ref={dropdownRef}
            className={`${c["dropdown-options-container"]} ${dropUp ? c["drop-up"] : c["drop-down"]}`}
          >
            {groupOptions.map((option) => (
              <SelectOneItem
                key={option.id}
                value={option.value}
                isSelected={selectedOption === option.value}
                onSelect={() => handleOptionSelect(option.value, option.id)}
                usedInMore={true}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
}

export default SelectMoreItem;
